<template>
  <el-dialog :title="title" v-bind="$attrs" @close="close" :visible="visible">
    <el-form :model="syncForm">
      <!-- 选择同步系统 -->
      <el-form-item v-show="isSync" label="系统选择：">
        <el-radio
          v-model="syncForm.system"
          v-for="(item, key) in system_list"
          :key="key"
          :label="key"
          :value="item"
          :disabled="sysDisabled(key)"
        >{{ item }}</el-radio>
      </el-form-item>

      <el-form-item v-if="isSyncToFib" label="国家选择：">
        <el-radio v-for="item in hopeCountries" v-model="syncForm.to" :label="item.id" :key="item.id">{{ item.value }}</el-radio>
      </el-form-item>
      <!-- 发送通知 -->
      <el-form-item v-show="isMsg" label="系统选择：">
        <el-checkbox-group v-model="syncForm.messageTo">
          <el-checkbox
            v-for="(item, key) in system_list"
            :key="key"
            :label="key"
            :value="item"
            :disabled="!sysDisabled(key)"
          >{{ item }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item v-if="isSyncToTraining" label="意向语言：（可多选）">
        <el-checkbox-group v-model="syncForm.targetLan">
          <el-checkbox label="日语"></el-checkbox>
          <el-checkbox label="韩语"></el-checkbox>
          <el-checkbox label="雅思"></el-checkbox>
          <el-checkbox label="托福"></el-checkbox>
          <el-checkbox label="托业"></el-checkbox>
          <el-checkbox label="EJU"></el-checkbox>
          <el-checkbox label="修士"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item v-if="isSyncToYuke" label="意向项目：（可多选）">
        <el-checkbox-group v-model="syncForm.targetProject">
          <el-checkbox label="大外-日本"></el-checkbox>
          <el-checkbox label="大外-韩国"></el-checkbox>
          <el-checkbox label="大外-葡萄牙"></el-checkbox>
          <el-checkbox label="大外-马来西亚"></el-checkbox>
          <el-checkbox label="大工-新加坡"></el-checkbox>
          <el-checkbox label="中传-日本"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item>
        <el-input
          type="textarea"
          resize="none"
          :rows="4"
          v-model="syncForm.message"
          autocomplete="off"
          placeholder="请输入文字说明(必填)"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" :disabled="cannotSync" @click="confirmFunc">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { isEmpty } from '@/utils/utils';

import {
  // 同步类型
  FIB_TO_TRAINING,
  TRAINING_TO_FIB,
  FIB_TO_JOB,
  JOB_TO_FIB,
  TRAINING_TO_JOB,
  JOB_TO_TRAINING,
  // 各个系统同步创建人
  CREATOR_FIB_TO_TRAINING,
  CREATOR_FIB_TO_JOB,
  CREATOR_TRAINING_TO_FIB,
  CREATOR_TRAINING_TO_JOB,
  CREATOR_JOB_TO_FIB,
  CREATOR_JOB_TO_TRAINING,
} from '@/const/sync';

const defaultSyncToCountry = '83';

export default {
  name: 'SyncDialogs',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    confirm: {
      type: Function,
      default: function() {}
    },
    // 当前资源的ID
    from: {
      type: Number,
      required: true,
    },
    // 完成全部同步, 对应父组件，不应出现同步按钮
    finished: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'sync',
      validator(value) {
        return ['sync', 'msg'].indexOf(value) !== -1;
      }
    }
  },
  data() {
    return {
      syncForm: {
        to: defaultSyncToCountry, // 默认显示芥末日本
        targetLan: [],
        targetProject: [],
        system: '',
        messageTo: [], // 消息发送部门
      },
      system_list: [],
      syncInfo: [],
      isSubmit: false,
    };
  },
  computed: {
    title() {
      if (this.type === 'sync') {
        return '确认将该资源信息同步到其他系统吗？';
      }

      if (this.type === 'msg') {
        return '确认将该资源动态提醒同步到其他系统吗？';
      }
    },

    /**
     * 全部意向国家
     */
    hopeCountries() {
      let countriesCache = this.$lockr.get('dict_ds');
      countriesCache.online.country = countriesCache.online.country.filter((item) => {
        if ([675, 1868, 2044, 1880, 1882, 1938, 1943, 1944, 2040, 2042, 2043, 2070, 2069, 1878].indexOf(item.id) !== -1) {
          // console.log(item);
        }
        return [675, 1868, 2044, 1880, 1882, 1938, 1943, 1944, 2040, 2042, 2043, 2070, 2069, 1878].indexOf(item.id) === -1;
      });
      // console.log(countriesCache.online.country);
      return countriesCache.online.country;
    },
    /**
     * 不能同步
     */
    cannotSync() {
      // eslint-disable-next-line object-curly-newline
      const { message, to, targetLan, targetProject, messageTo } = this.syncForm;
      if (!message) {
        console.log('message is empty');
        return true;
      }
      if (this.isSync) {
        if (this.isSyncToFib && !to) {
          console.log('to is empty');
          return true;
        }
        if (this.isSyncToTraining && isEmpty(targetLan)) {
          console.log('targetLan is empty');
          return true;
        }
        if (this.isSyncToYuke && isEmpty(targetProject)) {
          console.log('targetProject is empty');
          return true;
        }
      }
      if (this.isMsg && isEmpty(messageTo)) {
        console.log(444);
        return true;
      }
      if (this.isSubmit) {
        console.log(555);
        return true;
      }
      return false;
    },
    /**
     * 是否同步给FIB
     */
    isSyncToFib() {
      const { system } = this.syncForm;
      return system === CREATOR_TRAINING_TO_FIB || system === CREATOR_JOB_TO_FIB;
    },
    /**
     * 是否同步给考培
     */
    isSyncToTraining() {
      const { system } = this.syncForm;
      return system === CREATOR_JOB_TO_TRAINING || system === CREATOR_FIB_TO_TRAINING;
    },
    /**
     * 是否同步给预科
     */
    isSyncToYuke() {
      const { system } = this.syncForm;
      return system === '-9999';
    },

    /**
     * 同步到就职
     */
    isSyncToJob() {
      const { system } = this.syncForm;
      return system === CREATOR_FIB_TO_JOB || system === CREATOR_TRAINING_TO_JOB;
    },
    syncTypes() {
      if (this.isFibSite) {
        return { [CREATOR_FIB_TO_JOB]: FIB_TO_JOB, [CREATOR_FIB_TO_TRAINING]: FIB_TO_TRAINING };
      }
      if (this.isJobSite) {
        return { [CREATOR_JOB_TO_FIB]: JOB_TO_FIB, [CREATOR_JOB_TO_TRAINING]: JOB_TO_TRAINING };
      }
      if (this.isTrainingSite) {
        return { [CREATOR_TRAINING_TO_FIB]: TRAINING_TO_FIB, [CREATOR_TRAINING_TO_JOB]: TRAINING_TO_JOB };
      }
      return {};
    },
    /**
     * 是否已经全部同步全其他系统
     */
    finishedSync() {
      return Object.keys(this.system_list).every(sys => this.syncInfo.some(item => item.creator === sys));
    },
    isSync() {
      return this.type === 'sync';
    },
    isMsg() {
      return this.type === 'msg';
    }
  },
  mounted() {
    this.getSiteDict();
    this.getSyncInfo();
  },
  methods: {
    /**
     * 站点字典
     */
    async getSiteDict() {
      const { data } = await this.$http._post({ url: '/index/student/getSyncSiteDic' });
      data['-9999'] = '预科系统';
      this.system_list = data;
      console.log(data);
    },
    /**
     * 资源同步信息，查找同步情况
     */
    async getSyncInfo() {
      const { data } = await this.$http._post({
        url: '/index/sync/read',
        data: {
          from: this.from,
          types: Object.values(this.syncTypes),
        }
      });
      this.syncInfo = data;
      const syncInfo = { finished: this.finishedSync, linked: !isEmpty(data), relation: data };
      this.$emit('loaded', syncInfo);
      this.$store.commit('setSyncInfo', syncInfo);
    },
    confirmFunc() {
      // if (!this.isSyncToFib) {
      //   delete this.syncForm.to;
      // }
      // 测试代码
      // if (this.syncForm) {
      //   console.log(this.syncForm);
      //   return false;
      // }

      if (this.isSync && isEmpty(this.syncForm.system)) {
        this.$message.error('请选择同步的系统');
        return false;
      }
      if (this.isMsg && isEmpty(this.syncForm.messageTo)) {
        this.$message.error('请选择消息提醒的系统');
        return false;
      }
      if (!this.syncForm.message) {
        this.$message.error('内容不能为空');
        return false;
      }
      if (this.isMsg) {
        this.sendMessage();
        return true;
      }
      this.isSubmit = true;
      this.$message.info('同步进行中...');
      this.$emit('confirm', this.syncForm);
    },
    close() {
      this.isSubmit = false;
      this.syncForm.system = '';
      this.syncForm.targetLan = [];
      this.syncForm.targetProject = [];
      this.syncForm.messageTo = [];
      this.syncForm.to = defaultSyncToCountry;
      this.syncForm.message = '';
      this.$emit('update:visible', false);
      this.getSyncInfo();
    },
    sysDisabled(val) {
      return this.syncInfo.some(item => item.creator === val && item.is_push === 1);
    },
    async sendMessage() {
      const types = [];
      Object.entries(this.syncTypes).forEach(([creator, type]) => {
        if (this.syncForm.messageTo.indexOf(creator) !== -1) {
          types.push(type);
        }
      });
      await this.$http._post({
        url: '/index/api_base/sendSyncMessage',
        data: { from: this.from, types, message: this.syncForm.message }
      });
      this.$message.success('发送同步消息成功');
      this.close();
    },
  },
  watch: {
    visible(v) {
      if (v) {
        this.getSyncInfo();
      }
    },
    from(v) {
      if (v) {
        this.getSyncInfo();
      }
    }
  },
};
</script>
<style>
.left-div {
  float: left;
}
</style>
